import * as THREE from 'three';
import type { GuestMarker } from '../../guests/guest-simulation.js';
import { mat } from '../world/palette.js';
import { SharedGeometries } from '../world/shared-geometries.js';

const CLIENT_TINTS = [0xc17a4a, 0xa86a52, 0xd4a574, 0x8b5a42];

function makeGuestMesh(index: number): THREE.Group {
  const g = new THREE.Group();
  const tint = CLIENT_TINTS[index % CLIENT_TINTS.length];
  const bodyMat = mat(tint, { roughness: 0.55 });
  const skin = mat(0xffd7b5, { roughness: 0.65 });
  const torso = new THREE.Mesh(new THREE.CapsuleGeometry(0.22, 0.55, 5, 10), bodyMat);
  torso.position.y = 0.95;
  torso.castShadow = true;
  const head = new THREE.Mesh(new THREE.SphereGeometry(0.19, 12, 10), skin);
  head.position.y = 1.42;
  head.castShadow = true;
  const shadow = new THREE.Mesh(
    SharedGeometries.contactShadow(),
    new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.22, depthWrite: false }),
  );
  shadow.rotation.x = -Math.PI / 2;
  shadow.position.y = 0.02;
  g.add(torso, head, shadow);
  return g;
}

export class GuestVisualLayer {
  readonly root = new THREE.Group();
  private pool: THREE.Group[] = [];

  sync(markers: GuestMarker[]): void {
    while (this.pool.length < markers.length) {
      const m = makeGuestMesh(this.pool.length);
      this.root.add(m);
      this.pool.push(m);
    }
    for (let i = 0; i < this.pool.length; i += 1) {
      const mesh = this.pool[i];
      if (i >= markers.length) {
        mesh.visible = false;
        continue;
      }
      mesh.visible = true;
      const mk = markers[i];
      mesh.position.x = mk.x;
      mesh.position.z = mk.z;
      const bob = mk.phase === 'dining' ? 0 : 0.04;
      mesh.position.y = bob;
      mesh.rotation.y = mk.phase === 'leaving' ? Math.PI : 0;
    }
  }
}
